export const bonuses = [
  {
    num: '01',
    title: 'Toolkit voor snelle aanpassingen',
    desc: 'Versies A, B en C voor elke oefening. Eén les die werkt voor groepen met verschillende niveaus.',
    value: '€12',
    image: 'https://cdn.magicpatterns.com/uploads/jBj84NuRtdcUov3siWREf3/BONUS_1.webp',
  },
  {
    num: '02',
    title: '20 kant-en-klare warm-ups',
    desc: 'Warm-ups afgestemd op elke sessie. In een korte én een volledige versie.',
    value: '€9',
    image: 'https://cdn.magicpatterns.com/uploads/qC9HBDNUpThmawxJwMcuCn/BONUS_2.webp',
  },
  {
    num: '03',
    title: '20 cool-downs en afsluitteksten',
    desc: 'Sluit elke les af als een pro. Inclusief teksten om je les krachtig af te ronden.',
    value: '€9',
    image: 'https://cdn.magicpatterns.com/uploads/sWCN2JoyyHJpCQ4HE33zc1/BONUS_3.webp',
  },
  {
    num: '04',
    title: '50 coachingzinnen en spreekscripts',
    desc: 'De exacte woorden om je groep te motiveren, te corrigeren en te leiden.',
    value: '€8',
    image: 'https://cdn.magicpatterns.com/uploads/isHsgBYCUhQ7S3pXzXr2rb/BONUS_4.webp',
  },
  {
    num: '05',
    title: 'Centrale planningsbundel',
    desc: 'Jaar-, maand-, week- en dagoverzicht voor het hele systeem. Nooit meer improviseren.',
    value: '€12',
    image: 'https://cdn.magicpatterns.com/uploads/9D4avh9bitCJGDcnbfZfZT/BONUS_5.webp',
  },
]
